import { Button, Tooltip } from "@chakra-ui/react";
import { DefaultTFuncReturn } from "i18next";
import { JSXElementConstructor, ReactElement } from "react";

interface ThresholdButtonProps {
  tooltipLabel: String | null;
  onClick?: () => void;
  operator?: DefaultTFuncReturn;
  leftIcon?: ReactElement<any, string | JSXElementConstructor<any>> | undefined;
}

export const ThresholdButton = ({
  tooltipLabel,
  onClick,
  operator,
  leftIcon,
}: ThresholdButtonProps) => {
  return (
    <Tooltip label={tooltipLabel} fontSize="sm" hasArrow>
      <Button
        w={4}
        minWidth={6}
        h={5}
        padding={0}
        variant="solid"
        bg="lightblue"
        color="#006699"
        onClick={() => onClick?.()}
        leftIcon={leftIcon}
      >
        {operator}
      </Button>
    </Tooltip>
  );
};
